const MIN_KEYWORD_LENGTH = 2

const ENDPOINT_LABEL_FIELDS = {
  from: ['permutationLabelFrom', 'routeLabelFrom'],
  to: ['permutationLabelTo', 'routeLabelTo']
}

function activeKeyword (value) {
  const keyword = String(value || '').trim().toLowerCase()
  if (keyword.length < MIN_KEYWORD_LENGTH) {
    return ''
  }
  return keyword
}

function matchesEndpoint (routeFareObj, side, keyword) {
  if (!keyword) {
    return true
  }

  const fields = ENDPOINT_LABEL_FIELDS[side] || []
  const labels = routeFareObj || {}
  return fields.some(function (field) {
    return String(labels[field] || '').toLowerCase().indexOf(keyword) > -1
  })
}

function isBlankFare (routeFareObj) {
  return !routeFareObj || !routeFareObj.fareDollar
}

function filterFarePermutations (fares, options) {
  const settings = options || {}
  const searchFrom = activeKeyword(settings.searchFrom)
  const searchTo = activeKeyword(settings.searchTo)
  const onlyBlankEntries = Boolean(settings.onlyBlankEntries)

  return (fares || []).filter(function (fare) {
    const routeFareObj = fare && fare.routeFareObj
    if (onlyBlankEntries && !isBlankFare(routeFareObj)) {
      return false
    }
    return matchesEndpoint(routeFareObj, 'from', searchFrom) &&
      matchesEndpoint(routeFareObj, 'to', searchTo)
  })
}

module.exports = {
  filterFarePermutations
}
